import BasicResource from '@/api/resource';

class Resource extends BasicResource {

    constructor () {
        super('tags');
    }

    tagsHandset (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/handset',
            params,
        });
    }

    tagsOS (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/os',
            params,
        });
    }

    tagsOther (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/other',
            params,
        });
    }

    tagsCarrier (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/carrier',
            params,
        });
    }

    tagsContentCategory (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/content_category',
            params,
        });
    }

    tagsPno (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/pno',
            params,
        });
    }

    tagsTheme (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/theme',
            params,
        });
    }

    tagsAdDimension (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/ad_dimension',
            params,
        });
    }

    tagsColor (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/color',
            params,
        });
    }

    tagsOperatingSystem (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/operating_system',
            params,
        });
    }

    tagsPlacement (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/placement',
            params,
        });
    }

    tagsStep (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/step',
            params,
        });
    }

    tagsBannerTitle (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/banner_title',
            params,
        });
    }

    tagsBannerId (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/banner_id',
            params,
        });
    }

    tagsBannerSource (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/banner_source',
            params,
        });
    }

    tagsProductPno (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/product_pno',
            params,
        });
    }

    tagsBannerFilename (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/banner_filename',
            params,
        });
    }

    tagsOfferDetailName (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/offer_detail_name',
            params,
        });
    }

    tagsHandsetLegacy (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/handset_legacy',
            params,
        });
    }

    tagsConnection (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/connection',
            params,
        });
    }

    tagsLanguage (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/language',
            params,
        });
    }

    tagsIsp (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/isp',
            params,
        });
    }

    tagsDeviceManufacturer (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/device_manufacturer',
            params,
        });
    }

    tagsFormFactor (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/form_factor',
            params,
        });
    }

    tagsTriggerParamClick (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/trigger_param_click',
            params,
        });
    }

    tagsTriggerParamEvent (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/trigger_param_event',
            params,
        });
    }

    tagsAdvBillingState (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/adv_billingstate',
            params,
        });
    }

    tagsAdvBillingContext (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/adv_billingcontext',
            params,
        });
    }

    tagsAdvBeOrderState (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/adv_beorderstate',
            params,
        });
    }

    tagsTriggerParamYieldr (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/trigger_param_yieldr',
            params,
        });
    }

    tagsCity (country, params = {}) {
        return this.client.request({
            method: 'get',
            path: `/publisher/v1/tags/city/${country}`,
            params,
        });
    }

    tagsCategory (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/tags/category',
            params,
        });
    }

    tagsTrafficTypes (params) {
        return this.client.request({
            method: 'get',
            path: '/publisher/v1/dict/partner-traffic-types',
            params,
        });
    }

}

export default new Resource();
